import { c as _c } from "react/compiler-runtime";
import type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import { Button } from '@headlessui/react';
import { cn } from '@/app/_lib/utils';
type SubscriptionTabsProps = {
  tabs: Subscription[];
  activeTab: Subscription;
  setActiveTab: React.Dispatch<React.SetStateAction<Subscription>>;
  className?: string;
};
export function SubscriptionTabs(t0) {
  const $ = _c(12);
  const {
    tabs,
    activeTab,
    setActiveTab,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex touch-pan-x gap-1 overflow-x-auto rounded-lg border border-slate-200 bg-slate-100 p-1", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeTab || $[3] !== setActiveTab || $[4] !== tabs) {
    let t3;
    if ($[6] !== activeTab || $[7] !== setActiveTab) {
      t3 = tab => <Button key={tab} className={cn("group rounded-xl px-4 py-1.5 hover:bg-backgroundHoverOverlay", activeTab === tab && "bg-white hover:bg-background")} onClick={() => setActiveTab(tab)}><p className={cn("text-nowrap text-contentSecondary", activeTab === tab && "font-medium text-slate-900")}>{tab}</p></Button>;
      $[6] = activeTab;
      $[7] = setActiveTab;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = tabs.map(t3);
    $[2] = activeTab;
    $[3] = setActiveTab;
    $[4] = tabs;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}